export const gitCommit = 'e24d7d93'
